<template>
  <Row>
    <packageTable
      ref="contentBaseRef"
      class="contentBaseRef"
      :columnsData="columnsheader"
      :tableData="tableDataList"
      :reduceheight="reduceheight"
      :loading="tableLoading"
      :border="true"
      :tabletotallen="getPageTotal"
      :showSearchBtn="false"
      :tablePageSize="reqBase.page_size"
      @getSelect="onSelectChange"
      @pageonChange="pageonChange"
      @pageSizeChange="pageSizeChange"
      @refreshBtn="init">
        <template slot="headLeft">
          <Form ref="formInline" :model="form_filter" class="tableHeaderForm" @keydown.enter.native="search" inline>
              <!-- <FormItem label="所属项目">
                <Input type="text" style="width:120px" v-model="form_filter.project_name" placeholder="所属项目"/>
              </FormItem> -->
              <FormItem label="">
                <Select v-model="form_filter.maintenance_type" filterable style="width:120px" placeholder="全部维保类型">
                  <Option v-for="(item,index) in maintenanceTypeList" :value="item.value" :key="index">{{ item.label }}</Option>
                </Select>
              </FormItem>
              <FormItem label="">
                <Select v-model="form_filter.status" filterable style="width:120px" placeholder="全部状态">
                  <Option v-for="item in statusList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
              <FormItem label="">
                  <DatePicker v-model="form_filter.datetime" placement="bottom-end" @on-change="timeChange" placeholder="请选择日期" style="width:120px"></DatePicker>
              </FormItem>
              <FormItem class="reduceFromMarginLeft">
                  <Button v-for="(item,index) in topButtonList" :type="item.type"
                          style="margin-right: 5px;" @click="item.method" :key="index">{{item.name}}</Button>
              </FormItem>
          </Form>
        </template>
        <template slot="headRight">
          <Tooltip  v-for="(item,index) in topButtonList2" :key="'down'+index"  :content="item.name" placement="bottom">
              <Button  
                  :type="item.type"      
                  style="margin-right: 5px;" 
                  @click="item.method" 
                  :key="index" 
                  :loading="item.loading"
                  :icon="item.icon"></Button>
          </Tooltip>
          <Tooltip v-for="(item,index) in topButtonList1" :key="index"  :content="item.name" placement="bottom">
              <Button  
                  :type="item.type"      
                  style="margin-right: 5px;" 
                  @click="item.method" 
                  :key="index" 
                  :icon="item.icon"></Button>
          </Tooltip>
        </template>
    </packageTable>
    <Modal v-model="visible" :footer-hide="true" width="1000">
      <Carousel v-model="carouselIndex" v-if="imgName.length>0" class="minHiehgt">
        <CarouselItem v-for="(item,index) in imgName" class="imgCarouseItem">
            <img 
            :key="'img'+index" 
            :src="item" 
            style="max-width: 100%;margin-bottom:10px;">
        </CarouselItem>
    </Carousel>
    </Modal>
  </Row>
</template>
<script>
import packageTableMixins from '@/mixins/packageTableMixins'
import addAppCustom from './components/addAppCustom'
import customDetails from './components/customDetails.vue'
import config from '@/config/index'
import {maintenance_audit,maintenance_list,maintenance_download,maintenance_report,getdownloadtoken,maintenance_download_zip} from '@/api/pests'
import {pests} from '@/api/api_url'
export default {
  name: "MechanismManage",
  mixins: [packageTableMixins],
  data() {
    return {
      selectItem:[],//当前所选项
      reduceheight:60,
      carouselIndex:0,
      visible:false,
      imgName:[],
      time:[],
      preventCateList:[],//防制分类
      alarmTypeList:[],//报警类型
      setData:null,
      currClientId:null,//当前选择的应用id
      form_filter:{
        project_name:null,
        alarm_type_code:null,
        cate_code:null,
        start_time:null,
        end_time:null,
        status:null
      },
      maintenanceTypeList:[
        {
          value:'',
          label:'全部'
        },
        {
          value:1,
          label:'定期维保'
        },
        {
          value:2,
          label:'临时维保'
        }
      ],
      statusList:[
        {
          value:'',
          label:'全部'
        },
        {
          value:0,
          label:'执行中'
        },
        {
          value:1,
          label:'未审核'
        },
        {
          value:2,
          label:'已审核'
        },
        {
          value:3,
          label:'审核失败'
        },
        {
          value:4,
          label:'取消'
        }
      ],
      //共用的查询与重置
      topButtonList:[
        {
          name:'查询',
          type:'primary',
          method:this.search
        },
        {
          name:'重置',
          type:'error',
          method:this.reset
        }
      ],
      topButtonList2:[
        {
          name:'批量下载',
          icon:'ios-cloud-download',
          type:'primary',
          method:this.downloadMul,
          loading:false
        }
      ],
      //共用的右侧添加按钮
      topButtonList1:[
        // {
        //   name:'添加',
          //icon:'ios-add',
        //   type:'primary',
        //   method:this.add
        // },
        {
          name:'刷新',
          icon:'ios-refresh',
          type:'primary',
          method:this.init
        }
      ],
      reqBase: {
        page:1,
        page_size:15
      },
      status: true,//是否企业认证
      tableDataList: [],
      getPageTotal: 0,
      operationButtonList:[
        {
          name:'维保报告',
          type:'text',
          icon:'md-clipboard',
          method:this.details
        },
        {
          name:'审核',
          type:'text',
          icon:'ios-create-outline',
          show:[1],
          method:this.add
        },
        {
          name:'详情',
          type:'text',
          icon:'ios-document-outline',
          show:[2,3],
          method:this.reviewResult
        },
        {
          name:'下载',
          type:'text',
          icon:'ios-cloud-download',
          show:[2],
          method:this.download
        },
      ],
      operationButtonList1:[
        {
          name:this.$t('operationModule.submitReview'),
          type:'text',
          icon:'',
          method:this.submitReview
        },
      ],
      columnsheader: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        // {
        //   align: 'center',
        //   title: '序号',
        //   minWidth:120,
        //   key: 'xuhao',
        // },
        //  {
        //   align: 'center',
        //   title: '所属项目',
        //   minWidth:120,
        //   key: 'project_name',
        // },
        // {
        //   align: 'center',
        //   title: '建筑物',
        //   minWidth:120,
        //   key: 'building_name',
        // },
        {
          align: 'center',
          title: '维保人员',
          minWidth:120,
          key: 'maintenance_user'
        },
        {
          align: 'center',
          title: '维保类型',
          minWidth:120,
          key: 'maintenance_type',
          render:(h,{row})=>{
            let color=''
            let text=""
            if(row.maintenance_type===1){
              color="success"
              text="定期维保"
            }else if(row.maintenance_type===2){
              color="primary"
              text="临时维保"
            }
            return h('Tag',{
              props:{
                color:color
              }
            },text)
          }
        },
        {
          align: 'center',
          title: '开始照片',
          minWidth:120,
          key: 'start_pic',
          render:(h,{row})=>{
            return h('a',{
              on:{
                click:()=>{
                  this.showImageList(row.start_pic)
                }
              }
            },row.start_pic.length)
          }
        },
        {
          align: 'center',
          title: '结束照片',
          minWidth:120,
          key: 'end_pic',
          render:(h,{row})=>{
            return h('a',{
              on:{
                click:()=>{
                  this.showImageList(row.end_pic)
                }
              }
            },row.end_pic.length)
          }
        },
        {
          align: 'center',
          title: '维保状态',
          minWidth:120,
          key: 'status',
          render:(h,{row})=>{
            let color=''
            let text=""
             if(row.status===0){
              color="primary"
              text="执行中"
            }else if(row.status===1){
              color="primary"
              text="未审核"
            }else if(row.status===2){
              color="success"
              text="已审核"
            }else if(row.status===3){
              color="error"
              text="审核失败"
            }else if(row.status===4){
              color="error"
              text="取消"
            }
            return h('Tag',{
              props:{
                color:color
              }
            },text)
          }
        },
        {
          align: 'center',
          title: '创建时间',
          minWidth:120,
          key: 'addtime'
        },
        {
          align: 'center',
          title: '操作',
          fixed: 'right',
          minWidth:130,
          key: 'Operating',
          render: (h, {row}) => {
            let arr=[];
            for(let i in this.operationButtonList){
                let list=this.operationButtonList[i];
                if(list.hasOwnProperty('show')){
                  if(list.show.indexOf(row.status)>-1){
                    arr.push(h('Button',{
                      style:{marginLeft:'5px',marginBottom:'3px',color:'#2d8cf0'},
                      props:{
                        type:list.type,
                        size:list.size?list.size:'small'
                      },
                      on:{
                        click:()=>{
                          list.method(row)
                        }
                      }
                    },list.name))
                  }
                }else{
                  arr.push(h('Button',{
                      style:{marginLeft:'5px',marginBottom:'3px',color:'#2d8cf0'},
                      props:{
                        type:list.type,
                        size:list.size?list.size:'small'
                      },
                      on:{
                        click:()=>{
                          list.method(row)
                        }
                      }
                    },list.name))
                }
              }
            return h('div',arr)
          }
        },
      ],
    }
  },
  components: {
    
  },
  props:{
    code:{},
    reducehe:{}
  },
  computed: {
    getAction(){
      let result = '';
      if (process.env.NODE_ENV === 'development') {
        result = config.baseUrl.dev + "" + pests.maintenance_download
      } else if (process.env.VUE_APP_BUILD === 'production') {
        result = config.baseUrl.pro + "" + pests.maintenance_download
      } else {
        result = config.baseUrl.alp + "" + pests.maintenance_download
      }
      return result;
    }
  },
  methods: {
    downloadMul(){
      if(this.selectItem.length>0){
        this.$set(this.topButtonList2[0],'loading',true)
        let data=this.selectItem
        let arr=[]
        for(let i in data){
          arr.push(data[i].id)
        }
        maintenance_download_zip({ids:arr}).then(res=>{
          this.$set(this.topButtonList2[0],'loading',false)
          if(res.result===0){
            let url=res.body.url
            this.$Message.success(res.errorMsg)
            window.open(url)
          }else{
            this.$Message.error(res.errorMsg)
          }
        }).catch(err=>{
          this.$set(this.topButtonList2[0],'loading',false)
        })
      }else{
        this.$Message.error('请选择需要加载的维保信息')
      }
      
    },
    /**
     * 选择发生变化
     */
    onSelectChange(selection){
      this.selectItem.splice(0)
      this.selectItem.push(...selection)
    },
    showImageList(imgList){
      this.imgName.splice(0)
      this.carouselIndex=0
      if(imgList && imgList.length===0){
          this.$Message.warning('暂无图片')
      }else{
        this.visible=true;
        this.imgName.push(...imgList)
      }
    },
    /**
     * 下载维保
     */
    download(row){
      let vm = this;
      let config = {
        loading: true,
        title: '下载',
        content:'您确定要下载此的维保吗',
        onOk: function () {
          let _this = this;
          getdownloadtoken({
            id:row.id,
            type:1
          }).then(res=>{
            if(res.result===0){
              let downloadtoken=res.body.downloadtoken
              let url=vm.getAction+'?id='+row.id+'&downloadtoken='+downloadtoken+'&type='+1
              window.open(url)
              vm.$Modal.remove()
            }else{
              _this.buttonLoading=false
              vm.$Message.error(res.errorMsg)
            }
          })
          
          
        }
      };
      this.$Modal.confirm(config);
    },
    timeChange(val){
      this.$set(this.form_filter,'datetime',val)
    },  
    mechanHome(row){
      window.open(config.webLinkUrl+'/index/'+row.company_code)
    },
    pageSizeChange(){

    },
    init() {
      this.tableLoading = true;
      this.selectItem.splice(0)
      maintenance_list({...this.reqBase}).then(res => {
        this.tableLoading = false;
        this.tableDataList = [];
        if (res.result === 0) {
          this.tableDataList = res.body.list || [];
          this.getPageTotal = res.body.total;
        }else{
          this.tableDataList = [];
          this.getPageTotal = 0;
          this.$Message.error(res.errorMsg);
        }
      });
    },
    //新增
    add(row) {
      let vm = this;
      let config = {
        loading: true,
        width: 800,
        render: (h) => {
          return h('div', [
            h('div', { style: { display: 'flex', justifyContent: 'space-between' } }, [
              h('h3', { style: { width: '100%', paddingBottom: '5px' } }, '审核'),
              h('icon', {
                props: { type: 'md-close', size: '16' },
                style: {
                  cursor: 'pointer'
                },
                on: {
                  'click': evt => {
                    vm.$Modal.remove()
                  }
                }
              })
            ]),
            h('Divider',{
              style:{
                margin:'8px 0'
              }
            }),
            h(addAppCustom, {
              ref: 'addAppCustom',
              props: {
                _vm: vm,
                $store:vm.$store,
                setData:row,
                edit:false,
              }
            })
          ])
        },
        onOk: function () {
          let _this = this;
          let obj = this.$refs.addAppCustom;
          obj.checkForm().then(res => {
            if (res) {
              //提交请求
              let {id,status,audit_remark,audit_user,handle_time} = obj.formModel;
              debugger
              maintenance_audit({id:row.id,status,audit_remark,audit_user,handle_time}).then(res => {
                let msg=res.errorMsg;
                if (res.result === 0) {
                  let msg=res.errorMsg;
                  vm.$Message.success(msg);
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(msg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    search(){
      this.onSearch(this.form_filter);
    },
    reset() {
      this.form_filter={
        project_name:null,
        alarm_type_code:null,
        cate_code:null,
        start_time:null,
        end_time:null,
        status:null
      };
      this.time.splice(0)
      this.search();
    },
    /**
     * 维保报告
     */
    details(row){
      let routeUrl = this.$router.push({
        name: "maintenanceReport",
        params: {id:row.id}
      });
      window.open(routeUrl.href, '_blank');
    },
    /**
     * 审核结果
     */
    reviewResult(row){
      let vm = this;
      let config = {
        loading: true,
        width: 800,
        okText:'关闭',
        render: (h) => {
          return h('div', [
            h('div', { style: { display: 'flex', justifyContent: 'space-between' } }, [
              h('h3', { style: { width: '100%', paddingBottom: '5px' } }, '审核详情'),
              h('icon', {
                props: { type: 'md-close', size: '16' },
                style: {
                  cursor: 'pointer'
                },
                on: {
                  'click': evt => {
                    vm.$Modal.remove()
                  }
                }
              })
            ]),
            h('Divider',{
              style:{
                margin:'8px 0'
              }
            }),
            h(customDetails, {
              ref: 'customDetails',
              props: {
                _vm: vm,
                $store:vm.$store,
                setData:row,
                edit:true,
              }
            })
          ])
        },
        onOk: function () {
          let _this = this;
          vm.$Modal.remove()
        }
      };
      this.$Modal.success(config);
    },
    edit(row) {
      let vm = this;
      let config = {
        loading: true,
        title: '处理',
        content:'您确定要处理'+row.device_name+'的告警吗',
        onOk: function () {
          let _this = this;
          maintenance_download({id:row.id}).then(res => {
            if (res.result === 0) {
              vm.$Message.success(res.errorMsg);
              vm.$Modal.remove();
              vm.init();
            } else {
              vm.$Message.error(res.errorMsg);
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    del(row) {
      let vm = this;
      let config = {
        loading: true,
        title: '处理告警',
        content:'您确定要处理'+row.device_name+'的告警吗',
        onOk: function () {
          let _this = this;
          maintenance_report({id:row.id}).then(res => {
            if (res.result === 0) {
              vm.$Message.success(res.errorMsg);
              vm.$Modal.remove();
              vm.init();
            } else {
              vm.$Message.error(res.errorMsg);
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    getAlertAbout(){
      maintenance_audit().then(res=>{
        if(res.result===0){
          this.alarmTypeList=res.body.alarm_type||[]
          this.preventCateList=res.body.prevent_cate||[]
          this.handleTypeList=res.body.handle_type||[]
        }
      })
    }
  },
  mounted() {
    if(this.code){
      this.$set(this.reqBase,'project_code',this.code)
    }
    if(this.reducehe){
      this.reduceheight=this.reducehe
    }else{
       this.init();
    }
  },
  created() {
  }
}
</script>
<style scoped>
  .div2 {
    font-size: 15px;
    text-align: center;
  }
  .contentBaseRef /deep/ .headerWrapper{
    align-items: center;
  }
  .minHiehgt{
    min-height: 500px;
  }
  .imgCarouseItem{
    text-align: center;
  }
  .contentBaseRef /deep/ .ivu-table-fixed, .contentBaseRef /deep/ .ivu-table-fixed-right {
    top: 48px !important;
  }
</style>
